'use client';

import { usePathname } from 'next/navigation';
import { getLocaleOrDefault, type Locale } from '@/lib/i18n';

/**
 * Extracts current locale from the URL path (e.g. /en/games -> 'en').
 * Use when LocaleProvider is not available (e.g. in root layout components).
 */
export function useLocaleFromPath(): Locale {
  const pathname = usePathname();
  const segment = pathname?.split('/').filter(Boolean)[0];
  return getLocaleOrDefault(segment);
}
